import { render, staticRenderFns } from "./EditComponent.vue?vue&type=template&id=769b6702&"
import script from "./EditComponent.vue?vue&type=script&lang=js&"
export * from "./EditComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports